import { useUserStore } from '../store/userStore';

/**
 * Get the Authorization headers object for API calls.
 * Reads the token from the Zustand store (synchronous).
 *
 * @returns {{ Authorization: string } | {}} Headers object or empty object if no token.
 */
export const authHeaders = () => {
  const token = useUserStore.getState().token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Get the bearer token string (used for WebSocket ?token= query param).
 *
 * @returns {string|null} The token or null.
 */
export const getAuthToken = () => {
  return useUserStore.getState().token || null;
};
